/**
 * The Light Edit — filmstrip (le-strip).
 *
 * The track scrolls on its own; this adds the arrows, the "1 / 6" count and
 * keyboard paging. Arrows ship hidden and are revealed here, so a page without
 * JS shows a plain scrollable row rather than dead buttons.
 *
 * Paging moves by a viewport of slides rather than one at a time: the frames are
 * different widths, so a fixed step would leave a photograph half cut off.
 */
(function () {
  function setUpStrip(strip) {
    var track = strip.querySelector('[data-le-strip-track]');
    var prev = strip.querySelector('.le-strip__arrow--prev');
    var next = strip.querySelector('.le-strip__arrow--next');
    var count = strip.querySelector('.le-strip__count');
    if (!track || !prev || !next) return;

    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;

    prev.hidden = false;
    next.hidden = false;

    function update() {
      var x = track.scrollLeft;
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = x <= 1;
      next.disabled = x >= max - 1;
      if (!count) return;
      // The leftmost slide still touching the viewport is the one being read.
      var idx = 0;
      slides.forEach(function (s, i) {
        if (s.offsetLeft <= x + 8) idx = i;
      });
      count.textContent = idx + 1 + ' / ' + slides.length;
    }

    function goNext() {
      var x = track.scrollLeft;
      var w = track.clientWidth;
      var max = track.scrollWidth - w;
      var target = slides.filter(function (s) {
        return s.offsetLeft + s.offsetWidth > x + w + 2;
      })[0];
      track.scrollTo({ left: target ? Math.min(target.offsetLeft, max) : max, behavior: 'smooth' });
    }

    function goPrev() {
      var x = track.scrollLeft;
      var w = track.clientWidth;
      var candidates = slides.filter(function (s) {
        return s.offsetLeft >= x - w - 2 && s.offsetLeft < x - 2;
      });
      track.scrollTo({ left: (candidates.length ? candidates[0] : slides[0]).offsetLeft, behavior: 'smooth' });
    }

    next.addEventListener('click', goNext);
    prev.addEventListener('click', goPrev);

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        goNext();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goPrev();
      }
    });

    track.addEventListener(
      'scroll',
      function () {
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );
    window.addEventListener('resize', update);

    // Slide widths come from the images, so recheck once they have loaded.
    track.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', update, { once: true });
    });

    update();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-le-strip]').forEach(setUpStrip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor: a block that is added or moved is re-rendered without a reload.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    init(e.target);
  });
})();
